
import images from 'url:./**/*.{png,jpg}'

const splitFileName = /^(.*)\/(.*?)$/

const imageMap = aggregatePaths(images, '', {})

function aggregatePaths(root, path, result) {
    switch (typeof(root)) {
        case 'string':
            const pathKey = path.replace(splitFileName, '$1.$2')
            result[pathKey] = root
            break;
        case 'object':
            Object.entries(root).forEach(([name, value]) => aggregatePaths(value, `${path}/${name}`, result))
            break;
    }
    return result
}

export default function getImage(path, defaultPath) {
    const url = imageMap[path] || imageMap[defaultPath]
    switch (typeof(url)) {
        case 'string':
            return url
        default:
            throw new Error(`${path} ${defaultPath ? `or ${defaultPath} ` : ''}could not be found`)
    }
}